import type { HelpFile } from '../../types/help'
import { EscalationThresholdsTestIds } from '../../../testids/EscalationThresholdsTestIds'

export const escalationThresholdsHelp: HelpFile = {
  docPage: '/docs/governance/workflow-escalations',
  texts: {
    [EscalationThresholdsTestIds.escalationThresholdsList]:
      'Konfigurierbare Kadenz und Empfänger:innen pro Anfragetyp und Risikostufe. Änderungen wirken nur auf neu aktivierte Schritte.',
    [EscalationThresholdsTestIds.editThresholdDialog]:
      'Kadenz-Tage, Eskalationsziel und IAM-Fachstelle-Empfänger:in für diese Schwelle bearbeiten.',
    [EscalationThresholdsTestIds.inputReminderDays]:
      'Tage nach Aktivierung bis zur ersten Erinnerung.',
    [EscalationThresholdsTestIds.inputFinalReminderDays]:
      'Tage nach Aktivierung bis zur letzten Erinnerung — muss grösser als die erste Erinnerung sein.',
    [EscalationThresholdsTestIds.inputManagerDays]:
      'Tage nach Aktivierung bis zur Eskalation an Vorgesetzte:n — muss grösser als die letzte Erinnerung sein.',
    [EscalationThresholdsTestIds.inputPlatformOwnerDays]:
      'Zusätzliche Tage nach der Vorgesetzten-Eskalation bis zur Benachrichtigung der IAM-Fachstelle.',
    [EscalationThresholdsTestIds.selectManagerTarget]:
      'Welche:r Vorgesetzte erhält die Eskalation: Vorgesetzte:r der aktuellen Approver:in oder Vorgesetzte:r der Objekteigner:in.',
    [EscalationThresholdsTestIds.checkboxActive]:
      'Inaktive Schwellen werden bei der Schrittaktivierung übersprungen; bestehende Snapshots bleiben unverändert.',
    [EscalationThresholdsTestIds.thRequestType]: null,
    [EscalationThresholdsTestIds.thRiskLevel]: null,
    [EscalationThresholdsTestIds.thReminderDays]: null,
    [EscalationThresholdsTestIds.thFinalReminderDays]: null,
    [EscalationThresholdsTestIds.thManagerDays]: null,
    [EscalationThresholdsTestIds.thPlatformOwnerDays]: null,
    [EscalationThresholdsTestIds.thManagerTarget]: null,
    [EscalationThresholdsTestIds.thActive]: null,
    [EscalationThresholdsTestIds.thActiveSnapshots]: null,
    [EscalationThresholdsTestIds.thActions]: null,
  },
}
